import { z } from 'zod';

// #193: Kommentar zur Testausführung — Freitext je Plan und Testfall, unabhängig vom Testlauf.
export const EXECUTION_COMMENT_MAX = 2000;

// Rumpf für Anlegen und Bearbeiten (POST/PATCH). Nur Text: Autor, Zeitstempel und Projekt/Plan/
// Testfall kommen aus Sitzung und Pfad, nie aus dem Rumpf.
export const ExecutionCommentBodySchema = z.object({
  body: z.string().trim().min(1).max(EXECUTION_COMMENT_MAX),
});
export type ExecutionCommentBody = z.infer<typeof ExecutionCommentBodySchema>;

export interface ExecutionCommentView {
  comment_id: string;
  body: string;
  author: { user_id: string; name: string } | null;
  created_at: string;
  updated_at: string;
  // updated_at liegt nach created_at — die Oberfläche zeigt „bearbeitet".
  edited: boolean;
  // Ob der Kommentar zum aktuellen Stand gehört (neuer als der letzte Lauf) oder ein vorheriger
  // ist: entscheidet die API per SQL-Prädikat, nicht der Client (kein last_run_at in der Antwort).
  current: boolean;
  // Darf der angemeldete Nutzer diesen Kommentar bearbeiten/löschen?
  can_edit: boolean;
}

export interface ExecutionCommentList {
  comments: ExecutionCommentView[];
  // Darf der angemeldete Nutzer in diesem Plan/Testfall einen Kommentar anlegen?
  can_write: boolean;
}
